import _extends from "@babel/runtime/helpers/extends";
import classnames from 'classnames';
import React from 'react';
import styles from './action-button-label.scss';
import { isString } from 'lodash';
export const ActionButtonLabel = _ref => {
  let {
    className,
    label,
    shortLabel
  } = _ref;
  return /*#__PURE__*/React.createElement("span", _extends({
    "data-hook": "action-button-label",
    className: classnames(className, styles.container)
  }, isString(label) && {
    'data-label': label
  }, shortLabel && {
    'data-short-label': shortLabel
  }), /*#__PURE__*/React.isValidElement(label) && label);
};
//# sourceMappingURL=action-button-label.js.map